export default __webpack_public_path__ + "static/media/speakers__rene-ritchie.3a626a51.jpg";